var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveRowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-desktop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M4.29291 7.29486C3.90236 7.68541 3.90236 8.31966 4.29291 8.71021L10.2917 14.709C10.6823 15.0996 11.3165 15.0996 11.7071 14.709C12.0976 14.3185 12.0976 13.6842 11.7071 13.2937L6.41437 8.00098L11.704 2.70826C12.0945 2.31771 12.0945 1.68346 11.704 1.29291C11.3134 0.902363 10.6792 0.902363 10.2886 1.29291L4.28979 7.29174L4.29291 7.29486Z",
    fill: "#003267"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveRowLeft);
export default __webpack_public_path__ + "static/media/move-row-left.5e4217a0cfb8146915ac6c8b78de8af0.svg";
export { ForwardRef as ReactComponent };